// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"2014":"6578ac0f5ed19cbc2441","8932":"51a0fb8afee11eec4de0"}[chunkId] + "";
};